import { questionGenerator } from '@/data/generators/questionGenerator';
import { FillInTheBlankOption } from '@/models/Answer';
import { FillInTheBlankQuestion, QuestionTypeEnum } from '@/models/Question';

export function fillInTheBlankOptionGenerator(
  option?: Partial<FillInTheBlankOption>,
): FillInTheBlankOption {
  return {
    id: 1,
    text: 'Opção A',
    altText: '',
    mediaFile: null,
    validPositions: [],
    ...option,
  };
}

export function fillInTheBlankQuestionGenerator(
  question?: Partial<FillInTheBlankQuestion>,
): FillInTheBlankQuestion {
  return {
    ...questionGenerator(question),
    question: '',
    options: [],
    ...question,
    type: QuestionTypeEnum.FILL_IN_THE_BLANK,
  };
}
